import styled from 'styled-components';
import { Props, Type } from './types';

type T = Pick<Props, 'type'>;
type TRecord = Record<Type, string>;

const backgroundColor = {
  info: '#cce5ff',
  warning: '#fff3cd',
  error: '#f8d7da',
  success: '#d4edda',
} as TRecord;

const borderColor = {
  info: '#b8daff',
  warning: '#ffeeba',
  error: '#f5c6cb',
  success: '#c3e6cb',
} as TRecord;

const color = {
  info: '#004085',
  warning: '#856404',
  error: '#721c24',
  success: '#155724',
} as TRecord;

export const AlertStyled = styled.div<T>`
  padding: 0.75rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  background-color: ${({ type }) => backgroundColor[type]};
  color: ${({ type }) => color[type]};
  border-color: ${({ type }) => borderColor[type]};
`;
